import * as React from 'react'
import { ReactElement } from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router'
import TimeOverview from '../v2/pages/Time/TimeOverview'
import GlobalTimeOverview from '../v2/pages/Time/GlobalTimeOverview'
import EntityPage, { EntityPageProps, ParentProps } from './EntityPage'
import GlobalTimeSuggestionOverview from './Time/GlobalTimeSuggestionOverview'
import TimeSuggestionOverview from './Time/TimeSuggestionOverview'

export const timeBaseUrl = '/time/:action?'

export default function Times(props: EntityPageProps): ReactElement {
    return (
        <EntityPage {...props} baseUrl={timeBaseUrl}>
            {({ route, baseUrl }: ParentProps) => (
                <Switch>
                    <Route
                        exact
                        path={`${route}/suggestion`}
                        render={(routeProps: RouteComponentProps) =>
                            props.currentFile === undefined ? (
                                <GlobalTimeSuggestionOverview baseUrl={baseUrl} />
                            ) : (
                                <TimeSuggestionOverview
                                    {...routeProps}
                                    {...props}
                                    fileId={props.currentFile?.id}
                                    baseUrl={baseUrl}
                                    localStorageKeyPrefix={`HammockTimeSuggestionOverview-${props.currentFile.id}-`}
                                />
                            )
                        }
                    />
                    <Route
                        path={route}
                        render={(routeProps: RouteComponentProps) =>
                            props.currentFile === undefined ? (
                                <GlobalTimeOverview baseUrl={baseUrl} />
                            ) : (
                                <TimeOverview
                                    {...routeProps}
                                    {...props}
                                    fileId={props.currentFile?.id}
                                    baseUrl={baseUrl}
                                    localStorageKeyPrefix={`HammockTimeOverview-${props.currentFile.id}-`}
                                />
                            )
                        }
                    />
                </Switch>
            )}
        </EntityPage>
    )
}
